import { BarChart,Bar,XAxis,YAxis,Tooltip,Legend,CartesianGrid,ResponsiveContainer,ComposedChart,Line,Rectangle,LabelList,Cell } from "recharts";

const GrowthChart = ({ data }) => {
  return (
    <div margin={{ top: 5, right: 30, left: 30, bottom: 5 }}>
      <ResponsiveContainer width="100%" height={400} style={{marginTop:10,marginBottom:10}}>
        <ComposedChart  data={data} barGap={3}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="branchcode" angle={-30}/>
          {/* <YAxis  domain={[0, dataMax => dataMax * 1.2]}/> */}
          <YAxis domain={['auto', 'auto']} />
          <Tooltip />
          <Legend />
            <Bar dataKey="diffProfitGrowth" name="Profit Growth" fill="green">
                <LabelList dataKey="diffProfitGrowth" position="top" fill="black" fontSize={14} />
                    {(data || []).map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.diffProfitGrowth < 0 ? "red" : "green"}/>
                        ))}
            </Bar>
        </ComposedChart >
      </ResponsiveContainer>
    </div>
  );
};

export default GrowthChart